enum Step {
    ButtonTypeSelection = 'ButtonTypeSelection',
    ButtonEdition = 'ButtonEdition',
}

export default Step;
